const ua = navigator.userAgent || '';

const isCordova = !!window.cordova;
const isElectron = /Electron/i.test(ua);
const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
const isAndroid = /Android/i.test(ua);
const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
const hasHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

const TV_UA = /\b(SMART-TV|SmartTV|Tizen|Web0S|WebOS|NetCast|BRAVIA|AFT[A-Z0-9]{1,7}|Android TV|AndroidTV|GoogleTV|Chromecast|CrKey|Roku|HbbTV|Viera|Philips|VIDAA|MiTV|SHIELD|TV Box|Xbox|PlayStation|LeanbackShell)\b/i;

function detectTV() {
    if (TV_UA.test(ua)) return true;
    // Android sin táctil y con pantalla grande: casi seguro un TV box.
    if (isAndroid && !hasTouch && Math.max(screen.width, screen.height) >= 1280) return true;
    return false;
}

export const device = {
    ua,
    isCordova,
    isElectron,
    isIOS,
    isAndroid,
    isSafari,
    hasTouch,
    hasHover,
    isTVAuto: detectTV(),
    isTV: false,
    isDesktop: !hasTouch && !isAndroid && !isIOS,
    isStandalone: window.matchMedia && window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true,
    // Safari/iOS reproduce HLS de forma nativa; hls.js necesita MSE.
    nativeHls: (function () {
        const v = document.createElement('video');
        return !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
    })(),
    mse: !!(window.MediaSource || window.WebKitMediaSource),

    /** Nombre descriptivo del dispositivo para la lista de sesiones: app o navegador + sistema. */
    deviceLabel() {
        if (isCordova) return isAndroid ? (this.isTV ? 'Android TV (app)' : 'Android (app)') : (isIOS ? 'iPhone/iPad (app)' : 'App');
        if (isElectron) return 'Escritorio (app)';
        const browser = /Edg\//.test(ua) ? 'Edge' : /OPR\//.test(ua) ? 'Opera' : /SamsungBrowser/.test(ua) ? 'Samsung Internet' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome' : isSafari ? 'Safari' : 'Navegador';
        const os = this.isTV ? 'Smart TV' : isIOS ? 'iOS' : isAndroid ? 'Android' : /Windows/.test(ua) ? 'Windows' : /Mac OS X/.test(ua) ? 'macOS' : /CrOS/.test(ua) ? 'ChromeOS' : /Linux/.test(ua) ? 'Linux' : '';
        return browser + (os ? ' · ' + os : '');
    },

    platformLabel() {
        if (isCordova) return isAndroid ? (this.isTV ? 'Android TV' : 'Android') : (isIOS ? 'iOS' : 'Cordova');
        if (isElectron) return 'Escritorio (Electron)';
        if (this.isTV) return 'Smart TV (web)';
        if (isIOS) return 'iOS (web)';
        if (isAndroid) return 'Android (web)';
        return 'Web';
    },

    applyMode(tvSetting, fireLayout = false) {
        // tvSetting: 'auto' | 'on' | 'off'. fireLayout: Ajustes y «Añadir fuente» con el aspecto del Fire TV también fuera de la tele.
        const tv = tvSetting === 'on' ? true : tvSetting === 'off' ? false : this.isTVAuto;
        this.isTV = tv;
        const html = document.documentElement;
        html.classList.toggle('mode-tv', tv);
        html.classList.toggle('fire-layout', tv || !!fireLayout);
        html.classList.toggle('mode-touch', hasTouch && !tv);
        html.classList.toggle('mode-desktop', !hasTouch && !tv);
        html.classList.toggle('is-ios', isIOS);
        html.classList.toggle('is-android', isAndroid);
        html.classList.toggle('is-cordova', isCordova);
        html.classList.toggle('is-electron', isElectron);
        return tv;
    }
};
